<template>
  <div>
    <b-row>
      <b-col>
        <AccountSelectInput @input="setAccount($event)" style="height: 10px" />
      </b-col>
      <b-col>
        <AccountPlanSearch @accountPlanSelected="setAccountPLan($event)" />
      </b-col>
      <!-- <b-col>
        <text-input
          @keyup.enter.native="select()"
          :alias="'Descrição'"
          v-model="searchForm.description"
        />
      </b-col> -->
    </b-row>

    <!-- <div class="row">
      <div class="col-md-3">
       
      </div>
      <div class="col-md-3 mr-3 ml-3">
 -->
    <!-- <text-input
          @keyup.enter.native="select()"
          :alias="'Caixa / Conta'"
          v-model="searchForm.account_description"
        /> -->

    <!-- </div>

      <div class="col-md-3">
        <text-input
          @keyup.enter.native="select()"
          :alias="'Plano de contas'"
          v-model="searchForm.account_plan_description"
        />
      </div>
    </div> -->
    <br />
    <b-row>
      <b-col>
        <number-input
          @keyup.enter.native="select()"
          :alias="'Valor mínimo'"
          v-model="searchForm.min_value"
          :minimumValue="-999999999"
        />
      </b-col>
      <b-col>
        <number-input
          @keyup.enter.native="select()"
          :alias="'Valor máximo'"
          v-model="searchForm.max_value"
          :minimumValue="-999999999"
        />
      </b-col>
      <b-col>
        <date-input
          @keyup.enter.native="select()"
          :alias="'Data inicial'"
          v-model="searchForm.date_start"
        />
      </b-col>
      <b-col>
        <date-input
          @keyup.enter.native="select()"
          :alias="'Data final'"
          v-model="searchForm.date_end"
        />
      </b-col>
      <b-col>
        <label label="control-label">&nbsp;</label>
        <br />
        <button class="btn btn-sm btn-primary" @click="select()">
          <i class="fas fa-search" /> Pesquisar
        </button>
      </b-col>
    </b-row>

    <!-- <div class="row">
      <div class="col-md-12 text-right">
        <button class="btn btn-sm btn-info" @click="exporta()">
          <i class="fas fa-file-excel"/> Exportar para Excel
        </button>
      </div>
    </div> -->

    <table-paginator :data="accountTransactions" @pagechange="select($event)">
      <br />
      <div class="row grid-table-heading">
        <div class="col-md-2">Conta / Caixa</div>
        <div class="col-md-2">Plano de contas</div>
        <div class="col-md-6">Descrição</div>

        <div class="col-md-2 text-right">Valor</div>
      </div>
      <hr />
      <template v-for="(row, index) in accountTransactions.data">
        <template v-if="dateChanged(index)">
          <div class="d-flex" :key="'date' + index">
            <span class="badge badge-info mt-4">
              {{ row.paid_at | dateBr }}
            </span>
            <span
              class="mt-4 ml-2"
              style="
                height: 1px;
                width: 100%;
                border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                padding-top: 8px;
              "
            />
          </div>
        </template>

        <div class="row grid-table-row" :key="index">
          <div class="col-md-2 col-6 mb-2 mb-md-0">
            <template v-if="row.account_type == 'c'">
              <span class="fa-stack">
                <i class="fas fa-circle fa-stack-2x text-success" />
                <i
                  class="fas fa-cash-register fa-stack-1x fa-inverse text-white"
                />
              </span>
            </template>
            <template v-else>
              <span class="fa-stack">
                <i class="fas fa-circle fa-stack-2x text-primary" />
                <i
                  class="fas fa-university fa-stack-1x fa-inverse text-white"
                />
              </span>
            </template>
            <span class="ml-1 text-primary">{{ row.account.description }}</span>
          </div>
          <div class="col-md-2 col-6 text-md-left text-right">
            {{ row.account_plan_description }}
          </div>
          <div class="col-md-6">
            <span class="fa-stack">
              <i class="fas fa-circle fa-stack-2x text-muted" />
              <i :class="[getIcon(row.origin), 'fa-stack-1x fa-inverse']" />
            </span>
            <span class="ml-2">{{ row.description }}</span>
            <span v-if="row.status == 'c'" class="badge badge-danger ml-2">
              Cancelado
            </span>
          </div>

          <div class="col-md-2 text-right">
            <b :class="[getValueClass(row.value)]" v-if="row.status != 'c'">
              {{ row.value | decimal }}
            </b>
            <s class="text-muted" v-else>{{ row.value | decimal }}</s>
          </div>
        </div>
      </template>
    </table-paginator>
    <error-handler :error="error" />
  </div>
</template>

<script>
import TablePaginator from "@/components/sections/TablePaginator";
import Filter from "@/mixins/Filters.js";
import moment from "moment";

import AccountSelectInput from "@/components/account/inputs/AccountSelectInput.vue";
import AccountPlanSearch from "@/components/account/search/accountPlanSearch.vue";
export default {
  components: {
    TablePaginator,
    AccountSelectInput,
    AccountPlanSearch,
  },

  data: function () {
    return {
      accountTransactions: {},

      searchForm: {
        description: null,
        account_description: null,
        account_plan_description: null,
        date_start: null,
        date_end: null,
        max_value: null,
        min_value: null,
        paginate: 40,
      },

      origin: {
        o: {
          text: "Vendas",
          icon: "fas fa-shopping-cart",
        },
        br: {
          text: "Contas a receber",
          icon: "fas fa-file-invoice-dollar",
        },
        bp: {
          text: "Contas a pagar",
          icon: "fas fa-file-invoice-dollar",
        },
        c: {
          text: "Lançamento",
          icon: "fas fa-pen",
        },
        t: {
          text: "Transferência",
          icon: "fas fa-exchange-alt",
        },
      },

      error: null,
    };
  },

  created() {
    this.select();
  },

  computed: {},

  methods: {
    async select(page = 1) {
      this.searchForm.page = page;
      this.$store.commit("showLoading");
      await this.$store
        .dispatch("accountTransaction/getTransactions", this.searchForm)
        .then((response) => {
          this.accountTransactions =
            this.$store.state.accountTransaction.transactions;

          this.$store.commit("pageHasLoaded");

          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("pageHasLoadedWithError", { error: error });

          this.$store.commit("hideLoading");
        });
    },

    // exporta() {
    //   this.$store
    //     .dispatch("accountTransaction/export", { params: this.searchForm })
    //     .then((response) => {
    //       const url = window.URL.createObjectURL(new Blob([response.data]));
    //       const link = document.createElement("a");
    //       link.href = url;
    //       link.setAttribute("download", "Movimentação Fluxo de caixa.xlsx");
    //       document.body.appendChild(link);
    //       link.click();
    //       this.$store.commit("hideLoading");
    //     })
    //     .catch((error) => {
    //       this.error = error;

    //       this.$store.commit("hideLoading");
    //     });
    // },

    getAccountPlan(row) {
      if (row.account_plan != null) {
        return row.account_plan.description;
      }
    },

    dateChanged(index) {
      if (index == 0) {
        return true;
      }

      if (
        this.accountTransactions.data[index].paid_at !=
        this.accountTransactions.data[index - 1].paid_at
      ) {
        return true;
      }

      return false;
    },

    getValueClass(val) {
      return val >= 0 ? "text-success" : "text-danger";
    },

    getIcon(origin) {
      try {
        return this.origin[origin].icon;
      } catch (error) {
        console.log(error);
      }
    },

    setAccountPLan(accountPlan) {
      this.searchForm.account_plan_id = accountPlan.id;
      this.select();
    },
    setAccount(account) {
      this.searchForm.account_id = account.id;
      this.select();
    },
  },
};
</script>

<style>
</style>
